import { FireUser } from './firestore-models/user';
import { User } from 'firebase/auth';

export class Session {
  isLogin: boolean;
  uid: string | null;
  token: string | null;
  authUser: User | null;
  user: FireUser | null;
  current_language: string;

  constructor() {
    this.isLogin = false;
    this.uid = null;
    this.token = null;
    this.authUser = null;
    this.user = null;
    this.current_language = 'ja';
  }

  reset(): Session {
    this.isLogin = false;
    this.uid = null;
    this.token = null;
    this.authUser = null;
    this.user = null;
    this.current_language = 'ja';
    return this;
  }

}
